module.exports = __webpack_public_path__ + "static/device-og--image-88d228a8b9ae5ad1cfa4c3fb5970cf15.jpg";